import {gql} from '@apollo/client'

export default gql`
  mutation Login($user_name: String, $password: String) {
    login(user_name: $user_name, password: $password) {
      id
      user_name
      role
      section_1_completed_date
      surveys {
        id
        title
        completed_date
        section_2_completed_date
        section_3_completed_date
        problems {
          id
        }
      }
    }
  }
`